import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ModalShell from "../ModalShell";
import type { ReceiptView } from "../ReceiptModal";
import styles from "./style.module.scss";

interface ReasonModalProps {
  open: boolean;
  receipt?: ReceiptView;
  onClose: () => void;
  title?: string;
}

/**
 * Why a payment was refused. Only a rejected transaction carries a reason, so
 * this opens from the row's flag rather than the receipt button.
 */
function ReasonModal({
  open,
  receipt,
  onClose,
  title = "Rejection reason",
}: ReasonModalProps) {
  if (!receipt) return null;

  return (
    <ModalShell
      open={open}
      onClose={onClose}
      title={title}
      subtitle={receipt.transactionId}
      width={460}
    >
      <div className={styles.reason}>
        <ErrorOutlineIcon className={styles.icon} />
        <div>
          {receipt.status && (
            <div className={styles.status}>{receipt.status}</div>
          )}
          <div className={styles.text}>
            {receipt.reason || "No reason was recorded for this payment."}
          </div>
        </div>
      </div>
    </ModalShell>
  );
}

export default ReasonModal;
